import { observer } from 'inferno-mobx';
import { h } from 'inferno-hyperscript';
import downloadImg from '../../img/laddaned.png';

import STATE from '../app/state.js';

function Row(props) {
    return h('tr', [
        h('th', props.k),
        h('td', props.v)
    ]);
}

const LakeInfoComponent = observer(function () {
    const lake = STATE.currentLake;
    
    if(lake === undefined) {
        return null;
    }
    
    const props = lake.properties;
    const reg = props.Register || {};

    const mapChild = props.Maps && props.Maps.length > 0
    ? h('a.download-link', {
        href: `./rest/downloadmap/${props.SJOID}`
    }, [
        `Ladda ner sjökartor för ${props.SJOID}`
    ])
    : null;
    return h('section', [
        h('h1', reg.SNAMN || ''),
        h('div.overflow-container', [
            h('table', { className: 'tableinfo' }, [
                h('tbody', [
                    h(Row, { k: 'Sjöidentitet', v: reg.SJOID}),
                    h(Row, { k: 'Vattendistrikt', v: props.DISTRICT}),
                    h(Row, { k: 'Vattenförekomstidentitet', v: props.EU_CD}),
                    h(Row, { k: 'SVAR-version', v: props.VERSION}),
                    props.Area && props.Area.Areal ? h(Row, { k: 'Sjöns totala area', v: `${props.Area.Areal} km² ${props.Area.info || ''}` }) : null,
                    props.Depth && props.Depth.Maxdjup ? h(Row, { k: 'Sjöns maxdjup', v: `${props.Depth.Maxdjup}` }) : null,
                    props.Depth && props.Depth.Medeldjup ? h(Row, { k: 'Sjöns medeldjup', v: `${props.Depth.Medeldjup}` }) : null,
                    props.Depth && props.Depth.Volym ? h(Row, { k: 'Sjöns volym', v: `${props.Depth.Volym} miljoner m³` }) : null,
                    props.VYHOJD ? h(Row, { k: 'Vattenytans höjd över havet (m)', v: `${props.VYHOJD}` }) : null,
                    (props.Maps||[]).map(m => {

                        let tiffMapName = m.TIFF != undefined ? m.TIFF : m.TIF;
                        let jpegMapName = m.JPEG != undefined ? m.JPEG : m.JPG;

                        return h(Row, { k: 'Sjökarta', v: [
                            `${tiffMapName}${jpegMapName}${m.PDF}`,
                            h('br'),
                            m.Anmärkning ? [ h('b', 'Anmärkning'), m.Anmärkning, h('br') ] : null,
                            m.UPPGIFTSLÄMNARE ? [ h('b', 'Uppgiftskälla'), m.UPPGIFTSLÄMNARE ] : null,
                            h('br'),
                            h('br')
                        ] })
                    })
                ])
            ])
        ]),
        mapChild
    ]);
});

export { LakeInfoComponent };
